module.exports = __webpack_public_path__ + "img/live2.6936517b.png";